import { findItemByType, isOutOfStock } from '../utils/shopItems'

// The GT-2 chassis takes the wheelbase either on the front face or under the
// chassis, and the two need different mounting plates. Price is identical, so
// the choice is deliberately NOT a price dimension and NOT a separate cockpit
// SKU (that would split the chassis stock pool in two). It rides as a zero-cost
// kit line item, so an incoming order shows which plate to pack, and as a
// gallery dimension so the photos match what was picked.
export const MOUNT_FRONT = 'front'
export const MOUNT_BOTTOM = 'bottom'
export const DEFAULT_MOUNT = MOUNT_FRONT

export const MOUNT_OPTIONS = [
  { id: MOUNT_FRONT, label: 'Front mount', itemType: 'GT2_FRONT_MOUNT_KIT' },
  { id: MOUNT_BOTTOM, label: 'Bottom mount', itemType: 'GT2_BOTTOM_MOUNT_KIT' },
]

export const isMount = (v) => v === MOUNT_FRONT || v === MOUNT_BOTTOM

// Resolve the mount options this region can actually order, by looking the kit
// itemTypes up in the offers payload.
//
// This is what makes the website deployable AHEAD of the backend that defines
// GT2_FRONT_MOUNT_KIT / GT2_BOTTOM_MOUNT_KIT: until those offers exist the list
// comes back empty and the configurator hides the mount control entirely,
// rather than letting a buyer pick "bottom mount" and sending an order that
// cannot say so. The control appears on its own once the backend deploy lands —
// no second website release needed.
export function resolveMountOptions(shopItems) {
  if (!Array.isArray(shopItems) || shopItems.length === 0) return []
  return MOUNT_OPTIONS
    .map((opt) => ({ ...opt, item: findItemByType(opt.itemType, shopItems) }))
    .filter((opt) => opt.item && !isOutOfStock(opt.item))
}
